import { z } from 'zod';

import { baseEntitySchema } from './baseContract';
import { PartnerClientLinkSource } from '../enums';

export const partnerClientLinkSchema = baseEntitySchema.extend({
  partnerOrganizationId: z.string().uuid(),
  clientOrganizationId: z.string().uuid(),
  createdByUserId: z.string().uuid().nullish(),
  source: z.nativeEnum(PartnerClientLinkSource),
});

export type PartnerClientLinkDTO = z.infer<typeof partnerClientLinkSchema>;

/**
 * SuperAdmin sets (or clears) which partner hub manages a given client org.
 * `partnerOrganizationId: null` removes the existing link.
 */
export const setClientPartnerSchema = z.object({
  clientOrganizationId: z.string().uuid(),
  partnerOrganizationId: z.string().uuid().nullable(),
  createdByUserId: z.string().uuid().nullish(),
});

export type SetClientPartnerDTO = z.infer<typeof setClientPartnerSchema>;

export const listPartnerLinksSchema = z.object({
  partnerOrganizationId: z.string().uuid(),
});

export type ListPartnerLinksDTO = z.infer<typeof listPartnerLinksSchema>;

/**
 * The current user's partner context, used by the admin app for menu
 * visibility, route guards, the org switcher, and the "Mine only" filter.
 */
export const partnerContextSchema = z.object({
  isPartnerCapable: z.boolean(),
  hubOrganizationIds: z.array(z.string().uuid()),
  accessibleOrganizationIds: z.array(z.string().uuid()),
  /** Client orgs attributed to the current user (`createdByUserId = me`). */
  myClientOrganizationIds: z.array(z.string().uuid()),
});

export type PartnerContextDTO = z.infer<typeof partnerContextSchema>;
